import styled from "styled-components";
export const TicketsStyle = styled.div`
  .ticket-holder {
    background-color: ${({ theme }) => theme.box};
    margin-top: 1rem;
    border-radius: 0.625rem;
    overflow: hidden;
  }
  .ticket-detail {
    background-color: ${({ theme }) => theme.box};
    margin-top: 1rem;
    border-radius: 0.625rem;
    padding: 10px;
  }
  .chat-holder {
    overflow-x: hidden;
    padding: 10px;
    height: 600px;
    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: #eff2f5 transparent;
  }
  .departmentselect {
  }
`;
